export default {
  buildings: [
  ],
  message_type: "BUILDING_STATE",
};
